import {getAttributes, Mark} from '@tiptap/core';
import {MarkType} from '@tiptap/pm/model';
import {Plugin, PluginKey} from '@tiptap/pm/state';

type ClickHandlerOptions = {
  type: MarkType;
};

function clickHandler(options: ClickHandlerOptions): Plugin {
  return new Plugin({
    key: new PluginKey(`handleClickLinkInner`),
    props: {
      handleClick: (view, _pos, event) => {
        if (event.button !== 0) {
          return false;
        }

        const eventTarget = event.target as HTMLElement;

        const attrs = getAttributes(view.state, options.type.name);
        const link = eventTarget.closest(`a`);

        const href = link?.href ?? attrs.href;
        const target = link?.target ?? attrs.target;

        if (link && href) {
          if (view.editable) {
            window.open(href, target);
          }

          return true;
        }

        return false;
      },
    },
  });
}

export const StyledLink = Mark.create({
  priority: 1000,
  addProseMirrorPlugins() {
    return [
      clickHandler({
        type: this.type,
      }),
    ];
  },
});
